import { render, staticRenderFns } from "./login-right-panel.vue?vue&type=template&id=001127c6&scoped=true&"
import script from "./login-right-panel.vue?vue&type=script&lang=js&"
export * from "./login-right-panel.vue?vue&type=script&lang=js&"
import style0 from "./login-right-panel.vue?vue&type=style&index=0&id=001127c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001127c6",
  null
  
)

export default component.exports